import { 
  ArrowRight, Compass, Heart, Map, Sparkles, 
  Star, Trophy, Zap, Globe, Camera, Coffee, LayoutGrid,
  Search
} from 'lucide-react';

import DealItem from "./DealItem";

const DealList = (props) => {

    const {
        bookingEngine,
        deals,
        PAGI_LIMIT,
        totalItems,
        setpagiCurrentPage,
        pagiCurrentPage,
    } = props;

    const all_pages = [1];
    let i=1;
    while(true){
        i+=PAGI_LIMIT;
        if(i>=totalItems){
            break
        }
        all_pages.push(i);
    }

    const packageTrendsPageBackground = "#fefeff";
    const packageTrendsPagePrimaryColor = "#5945e7";
    const packageTrendsPageSecondColor = "#ffffff";
    const packageTrendsPageThirdColor = "#0d0d0d";
    const packageTrendsPageFourthColor = "#eb0000";

    const styles = {
        hero: {
            background: (packageTrendsPagePrimaryColor || 'linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%)'),
            padding: '6rem 1rem',
            textAlign: 'center',
            color: '#ffffff',
            position: 'relative',
            overflow: 'hidden',
        },
        section: {
            padding: '5rem 1rem',
            maxWidth: '1200px',
            margin: '0 auto',
        },
        heading: {
            fontSize: '2.5rem',
            fontWeight: 900,
            color: '#0f172a',
            marginBottom: '1rem',
            textAlign: 'center',
            letterSpacing: '-0.025em',
        },
        subHeading: {
            fontSize: '1.125rem',
            color: '#64748b',
            textAlign: 'center',
            marginBottom: '3.5rem',
            maxWidth: '600px',
            margin: '0 auto 3.5rem auto',
        },
        card: {
            backgroundColor: '#ffffff',
            borderRadius: '1.5rem',
            overflow: 'hidden',
            boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.04)',
            border: '1px solid #f1f5f9',
            transition: 'transform 0.3s ease, box-shadow 0.3s ease',
        },
        badge: {
            position: 'absolute',
            top: '1rem',
            left: '1rem',
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
            padding: '0.4rem 0.8rem',
            borderRadius: '999px',
            fontSize: '0.75rem',
            fontWeight: 800,
            color: (packageTrendsPagePrimaryColor || '#4f46e5'),
            display: 'flex',
            alignItems: 'center',
            gap: '0.4rem',
            backdropFilter: 'blur(4px)',
        },
        inputWrapper: {
          display: 'flex',
          alignItems: 'center',
          gap: '0.75rem',
          padding: '0.75rem 1rem',
          backgroundColor: '#f8fafc',
          borderRadius: '0.85rem',
          border: '1px solid #e2e8f0',
          transition: 'all 0.2s ease',
        },
    };

    const test_packages = [
        {
            _id: 1,
            title: "Neon Nights in Tokyo",
            location: "Tokyo, Japan",
            duration: "9 Days",
            price: "$2,499",
            image: "https://images.unsplash.com/photo-1540959733332-eab4deabeeaf?auto=format&fit=crop&w=800&q=80",
            tag: "Best Seller"
        },
        {
            _id: 2,
            title: "Amalfi Coast Dream",
            location: "Amalfi, Italy",
            duration: "7 Days",
            price: "$1,850",
            image: "https://images.unsplash.com/photo-1533105079780-92b9be482077?auto=format&fit=crop&w=800&q=80",
            tag: "Relaxing"
        },
        {
            _id: 3,
            title: "Icelandic Adventure",
            location: "Reykjavik, Iceland",
            duration: "10 Days",
            price: "$3,100",
            image: "https://images.unsplash.com/photo-1476610182048-b716b8518aae?auto=format&fit=crop&w=800&q=80",
            tag: "Bucket List"
        }
    ];

    return <div>
        <h2 dangerouslySetInnerHTML={{ __html: ("Trending This Season") }}
              style={{...styles.heading, /*display: "none"*/ margin: 10, paddingTop: 20}}></h2>
        <p dangerouslySetInnerHTML={{ __html: ("The most exclusive packages by our community, refreshed every week with exclusive experiences.") }}
              style={{...styles.subHeading, /*display: "none"*/}}></p>
        <div style={{padding: "5px 10px", display: "flex", justifyContent: "space-between", alignItems: "center"}}>
            {/*<div>
                <p style={{color: "grey", fontSize: 12}}>
                    <span style={{color: "blue", margin: 5, fontSize: 13}}>{totalItems}</span> 
                    item(s) found
                </p>
            </div>*/}
            <div style={styles.inputWrapper} className="hover:border-indigo-200 hover:bg-white focus-within:border-indigo-400 focus-within:bg-white">
                <Search style={{ width: "24px", height: "24px" }} className="text-slate-400" />
                <input id="__"
                    type="text"
                    placeholder="Enter City, Country, or Title"
                    className="bg-transparent -border-none -outline-none text-sm -font-bold text-slate-900 w-full"
                />
            </div>
            <div>
                <select onInput={e=>setpagiCurrentPage(e.target.value)}
                    value={pagiCurrentPage}
                    style={{/*backgroundColor: bookingEngine?.actionButtonsBg, color: bookingEngine?.actionButtonsTxtColor,*/ background: "none", color: "black"}}
                    className="select-input-paginator"
                >
                    {
                        all_pages?.map((each, i)=>{
                            return <option style={{backgroundColor: bookingEngine?.actionButtonsBg, color: bookingEngine?.actionButtonsTxtColor}}
                                value={each}
                            >{each} - {(each+PAGI_LIMIT)}</option>
                                
                        })  
                    }
                </select>
            </div>
        </div>
        <div style={{display: "flex", flexWrap: "wrap", paddingBottom: 20}}>
            {
                deals.map(each=><DealItem 
                    data={each}
                />)
            }
        </div>
            <p style={{display: "none"}}>Type 4 Page</p>
            <div style={{display: "none"}} className="grid grid-cols-1 md:grid-cols-3 gap-1">
                {test_packages.map((trip, idx) => (
                <div 
                    key={idx} 
                    style={styles.card} 
                    className="group cursor-pointer hover:shadow-2xl hover:shadow-indigo-100 transition-all hover:translate-y-[-4px]"
                >
                    <div className="relative h-64 overflow-hidden">
                    <img src={trip.image} alt={trip.title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />
                    <div style={styles.badge}>
                        <Star style={{width: "16px", height: "16px"}} fill="currentColor" /> {trip.tag}
                    </div>
                    </div>
                    <div className="p-6">
                    <div className="flex items-center gap-2 text-[10px] font-black text-indigo-600 uppercase tracking-widest mb-3">
                        <Map style={{width: "16px", height: "16px"}} /> {trip.location}
                    </div>
                    <h3 className="text-xl font-black text-slate-900 mb-2">{trip.title}</h3>
                    <div className="flex items-center justify-between mt-6 pt-4 border-t border-slate-50">
                        <span className="text-sm font-bold text-slate-400">{trip.duration}</span>
                        <div className="text-right">
                        <span className="block text-[10px] font-black text-slate-300 uppercase">From</span>
                        <span className="text-lg font-black text-indigo-600">{trip.price}</span>
                        </div>
                    </div>
                    <div className="mt-4 flex items-center justify-center gap-2 text-indigo-600 font-black text-[10px] uppercase tracking-widest opacity-0 group-hover:opacity-100 transition-opacity">
                        View Full Journey <ArrowRight style={{width: "16px", height: "16px"}} />
                    </div>
                    </div>
                </div>
                ))}
            </div>
    </div>
}

export default DealList;